import * as React from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
    modalContent: React.ReactNode;
    onClose?: () => void;
    headerText?: string;
}

interface IState {
    isOpen: boolean;
}

export class SuccessfulConfirmationModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true
        }

        this.close = this.close.bind(this);
    }

    public render(): React.ReactNode {
        const closeBtn = <button className="btn-close" onClick={this.close}/>

        return (
            <Modal className="falcon-modal purchase-success-modal tablet-w-100-procent" isOpen={this.state.isOpen}>
                <ModalHeader className="pb-0" close={closeBtn} >
                    <div className="d-flex title-container">
                        <div className="d-flex purchase-success-icon-container mb-0">
                            <img className="purchase-success-icon d-block w-25"
                                 src={`/${resourcesHelper.THEME_PATH}/img/check-mark-green-light.svg`}
                                 alt="DriveAway complete confirmation"
                                 aria-label="DriveAway complete picture"
                            />
                            <h1 id="success-modal-title" className="success-modal-title success-modal-title-driveaway text-nowrap mb-0">{this.props.headerText? this.props.headerText : "All done"}</h1>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="success-modal-content">
                        {this.props.modalContent}
                    </div>
                </ModalBody>
                <ModalFooter className="flex-column">
                    <button type="button"
                        className="btn btn-blue-dashboard mb-0 mt-0"
                        onClick={this.close}
                    >
                        Get started
                    </button>
                </ModalFooter>
            </Modal>
        )
    }

    private close(): void {
        window.sessionStorage.removeItem("showPopup");

        this.setState({
            isOpen: false
        });

        if (this.props.onClose) {
            this.props.onClose();
        }
    }

}
